module.exports = __webpack_public_path__ + "96251067f64c18df2d25c2d118f1509b.png";